import { BlocksIconInfo } from 'blocks-nextjs/blocks-web-components/components/icon/icons/info';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconInfo = createComponent({ react: React, tagName: 'cat-icon-info', elementClass: BlocksIconInfo });
